export default function() {
  var gaEvent = new window.GAEvent();

  var registerEmbedEvents = [
    ["widget", "embed:play_once", "play video / [partner_site] / [video_owner] / [video_title]", "body.embed.videos", "", {}, ["partner_site", "video_owner", "video_title"]],
    ["widget", "scroll:embed:collection", "view collection / [partner_site] / [video_owner] / [page_number]", "body.embed.videos", "", {}, ["page_number", "video_owner", "partner_site"]],
    ["widget", "click", "play video collection / [partner_site] / [video_owner] / [video_id] / [video_category]", "body.embed.videos", ".ga-embed__play-collection-video", {video_owner: "videoOwner", video_id: "videoId", video_category: "videoCategory" }],
    ["widget", "click", "user follow / [video_owner]", "body.embed.videos", ".button-follow:not(.button-follow--following)", {video_owner: "username"}],
    ["widget", "click", "user unfollow / [video_owner]", "body.embed.videos", ".button-follow.button-follow--following", {video_owner: "userId"}],
    ["widget", "click", "user comment / [video_owner] / [video_id]", "body.embed.videos", ".ga-embed__comments", {video_owner: "videoOwner", video_id: "videoId"}],
    ["widget", "click", "user profile", "body.embed.videos", ".ga-embed__user-profile"],
    ["widget", "click", "like video / [video_owner] / [video_id]", "body.embed.videos", ".ga-embed__video-like[data-flag='like']", {video_owner: "votableOwner", video_id: "votableId"}],
    ["widget", "click", "unlike video / [video_owner] / [video_id]", "body.embed.videos", ".ga-embed__video-like[data-flag='unlike']", { video_owner: "votableOwner", video_id: "votableId"}],
    ["widget", "click", "go to vidio", "body.embed.videos", ".ga-embed__go-to-vidio"]
      ];

  var registerVideoJSErrorMessageEvents = [
    ["widget", "click", "install chrome", undefined, ".vjs-player-error__link--chrome"],
    ["widget", "click", "install firefox", undefined, ".vjs-player-error__link--firefox"],
    ["widget", "click", "install flash", undefined, ".vjs-player-error__link--flash"]
      ];

  registerEmbedEvents.forEach(function(event){
    gaEvent.registerEvent.apply(gaEvent, event);
  });

  registerVideoJSErrorMessageEvents.forEach(function(event){
    gaEvent.registerEvent.apply(gaEvent, event);
  });
}
